import type { ReportParamFilters } from '@core/reports-types';

export const decodeFiltersQuery = (query: string): ReportParamFilters => {
  if (query === '' || query === null) {
    return [];
  }

  return query.split(';').reduce(
    (acc, el) => {
      if (el === '') {
        return acc;
      }

      const [group, value] = el.split(/:(.*)/s);

      if (!group && !value) return acc;
      const groupWoPrefix = group.replace(/__not__/, '');
      const inverse = group !== groupWoPrefix;
      return [...acc, { group: groupWoPrefix, value, inverse }];
    },
    <ReportParamFilters>[],
  );
};
export const encodeFiltersQuery = (filters: ReportParamFilters): string => {
  const groupMap = filters.reduce(
    (acc, filter) => {
      if (acc[filter.group]) {
        acc[filter.group].push({ value: filter.value, inverse: filter.inverse ?? false });
      } else {
        acc[filter.group] = [{ value: filter.value, inverse: filter.inverse ?? false }];
      }

      return acc;
    },
    <Record<string, Array<{ value: string; inverse: boolean }>>>{},
  );

  return Object.entries(groupMap).reduce(
    (acc, [key, values]) =>
      values !== null
        ? values.reduce(
            (_acc, { value, inverse }) => `${_acc}${inverse ? '__not__' : ''}${key}:${value};`,
            acc,
          )
        : acc,
    '',
  );
};
